import { AppBar, Toolbar, IconButton, Typography, Box, Stack } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { useTheme } from '@mui/material/styles'
import { AdminBadge } from './AdminBadge'
import { Logo } from '~/components/Logo/Logo'
import { BRANDING } from '~/config/branding'

interface Props {
  user: { email: string }
  drawerOpen: boolean
  onToggle: () => void
}

export function TopBar({ user, drawerOpen, onToggle }: Props) {
  const theme = useTheme()
  return (
    <AppBar position="fixed" sx={{ zIndex: theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label={drawerOpen ? 'close drawer' : 'open drawer'}
          onClick={onToggle}
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>
        <Logo height={28} />
        <Typography variant="h6" noWrap sx={{ ml: 1.5, fontWeight: 600 }}>
          {BRANDING.productTitle}
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Typography variant="caption" sx={{ opacity: 0.85 }}>
            {user.email}
          </Typography>
          <AdminBadge />
        </Stack>
      </Toolbar>
    </AppBar>
  )
}
